import { z } from 'zod';

export const AssetPerformanceDataPointSchema = z.object({
  date: z.string(),
  timestamp: z.string(),
  price: z.number(),
  volume: z.number(),
});

export const AssetPerformanceStatsSchema = z.object({
  currentPrice: z.number(),
  priceChangeYesterday: z.number(),
  priceChange: z.number(),
  highest: z.number(),
  lowest: z.number(),
  volatility90d: z.number(),
  totalVolume: z.number(),
  beta: z.number(),
});

export const AssetPerformanceSMALagDataPointSchema = z.object({
  timestamp: z.string(),
  value: z.number(),
});

export const AssetPerformanceDataSchema = z.object({
  stats: AssetPerformanceStatsSchema,
  data: z.array(AssetPerformanceDataPointSchema),
  smaLagData: z.array(AssetPerformanceSMALagDataPointSchema).optional(),
});

export type AssetPerformanceDataPoint = z.infer<typeof AssetPerformanceDataPointSchema>;
export type AssetPerformanceSMALagDataPoint = z.infer<typeof AssetPerformanceSMALagDataPointSchema>;
export type AssetPerformanceStats = z.infer<typeof AssetPerformanceStatsSchema>;
export type AssetPerformanceData = z.infer<typeof AssetPerformanceDataSchema>;
